import { Link, LinkifyText } from '@pandiafi/design-system'
import { ContextNotification } from '@pandiafi/components'
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'

export const SignInContextNotification: FC<{
  text: string
  type?: 'success' | 'error'
  additionalLink?: { url: string; text: string }
}> = ({ text, type = 'success', additionalLink }) => {
  const navigate = useNavigate()
  const textPart = (
    <div className="text-center font-light">{LinkifyText(text)}</div>
  )
  return (
    <ContextNotification type={type} className="mb-6">
      {!additionalLink && textPart}
      {additionalLink && (
        <div className="flex flex-col gap-2 items-center">
          {textPart}
          <div className="flex text-center">
            <Link
              to={additionalLink.url}
              onPress={() => {
                navigate(additionalLink.url)
              }}
            >
              {additionalLink.text}
            </Link>
          </div>
        </div>
      )}
    </ContextNotification>
  )
}
